$(window).on('load', function () {
    $('.loader').fadeOut('slow');
    setTimeout(function () {
        $('.wrapper').removeClass('hide-wrapper');
    }, 0);
});

function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

function getUrlParameter(sParam) {
    let sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
}

function getCardColorImages(colorId) {

    $('.loader').removeAttr('style');
    $('.wrapper').addClass('hide-wrapper');

    $.ajax({
        type: "POST",
        url: window.location.href,
        data: {
            color_id: colorId
        },
        success: function (response) {
            $('.image-card').remove();
            $('.card__wrapper').prepend(JSON.parse(response).html);
            $('.info-card__price').find('span').first().text(JSON.parse(response).prices.price + '.-');

            if (JSON.parse(response).prices.inStock == 0) {
                $('.info-card__cart').css('display', 'none');
            } else {
                $('.info-card__cart').removeAttr('style');
            }

            if (JSON.parse(response).prices.old_price != '' && JSON.parse(response).prices.old_price != '0') {
                let old_price_text = JSON.parse(response).prices.old_price + '.-';
                $('.info-card__price').find('._old').removeAttr('style');
                $('.info-card__price').find('._old').text(old_price_text);
            } else {
                $('.info-card__price').find('._old').css('display', 'none');
            }
        },
        complete: function () {
            let sliders = document.querySelectorAll('._swiper');
            if (sliders) {
                for (let index = 0; index < sliders.length; index++) {
                    let slider = sliders[index];
                    if (!slider.classList.contains('swiper-bild')) {
                        let slider_items = slider.children;
                        if (slider_items) {
                            for (let index = 0; index < slider_items.length; index++) {
                                let el = slider_items[index];
                                el.classList.add('swiper-slide');
                            }
                        }
                        let slider_content = slider.innerHTML;
                        let slider_wrapper = document.createElement('div');
                        slider_wrapper.classList.add('swiper-wrapper');
                        slider_wrapper.innerHTML = slider_content;
                        slider.innerHTML = '';
                        slider.appendChild(slider_wrapper);
                        slider.classList.add('swiper-bild');

                        if (slider.classList.contains('_swiper_scroll')) {
                            let sliderScroll = document.createElement('div');
                            sliderScroll.classList.add('swiper-scrollbar');
                            slider.appendChild(sliderScroll);
                        }
                    }
                }
                sliders_bild_callback();
            }

            let cardThumb = new Swiper(".thumbs-image-card__slider", {
                spaceBetween: 0,
                slidesPerView: 'auto',
                freeMode: false,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: ".thumbs-image-card-arrow-next",
                    prevEl: ".thumbs-image-card-arrow-prev",
                },
            });

            new Swiper(".main-image-card__slider", {
                spaceBetween: 10,

                slidesPerView: 'auto',
                freeMode: false,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: ".next-slide",
                    prevEl: ".prev-slide",
                },

                thumbs: {
                    swiper: cardThumb,
                },
            });

            $('.loader').fadeOut('slow');
            setTimeout(function () {
                $('.wrapper').removeClass('hide-wrapper');
            }, 0);
        }
    });
}

function calculate_cart_items() {
    let total = 0;
    let itemQuantity = 0;

    $('._new_price').each(function () {
        total = total + (parseFloat($(this).attr('data-price')) * parseInt($(this).parent().prev().find('.quantity__input').find('input').val()));
    });

    $('.footer-cart-header__total').find('span').text(total.toLocaleString(undefined, {
        minimumFractionDigits: 0
    }) + '.-');
}

let priceAfterAjax;

function update_product_amount(productKey, amount) {
    $.ajax({
        type: 'POST',
        url: '/update_product_amount',
        data: {
            productKey: productKey,
            amount: amount
        },
        success: function (response) {
            // cart_total.text(JSON.parse(response).price.toLocaleString(undefined, {
            //     minimumFractionDigits: 0
            // }) + '.-');
            // new_price.text(JSON.parse(response).price.toLocaleString(undefined, {
            //     minimumFractionDigits: 0
            // }) + '.-');

            priceAfterAjax = JSON.parse(response).price.toLocaleString(undefined, {
                minimumFractionDigits: 0
            }) + '.-';

            $('.footer-cart-header__total span').text(JSON.parse(response).total.toLocaleString(undefined, {
                minimumFractionDigits: 0
            }) + '.-');

            $('.sidebar_total').text(JSON.parse(response).total.toLocaleString(undefined, {
                minimumFractionDigits: 0
            }) + '.-');

            $.ajax({
                type: 'GET',
                url: '/count_cart_items',
                success: function (response) {
                    $('.action-main-header__count').text(response);
                }
            });
        }
    });
}

function calculate_cart_items_page() {
    let total = 0;

    $('.product-main-cart__total').each(function () {
        total = total + parseInt($(this).text().replace('.-', '').replace(',', ''));
    });

    $('.sidebar_total').text(total.toLocaleString(undefined, {
        minimumFractionDigits: 0
    }) + '.-');
}

$(document).ready(function () {

    if (getUrlParameter('tag')) {
        $('.tags_filter div').each(function () {
            let currentAttribute = $(this).attr('data-id');
            if (currentAttribute == getUrlParameter('tag')) {
                $(this).addClass('active');
            }
        });
    }

    $(document).on('click', '.tags_filter div', function () {
        let currentElement = $(this);
        let currentId = currentElement.attr('data-id');

        if (currentElement.hasClass('active')) {
            currentElement.removeClass('active');
            window.location.href = window.location.href.split('?')[0];
        } else {
            currentElement.addClass('active');
            window.location.href = window.location.href.split('?')[0] + '?tag=' + currentId;
        }
    });

    $('.search-header__input').keyup(function (event) {
        let searchUrl = $(this).attr('data-search');
        event.preventDefault();

        $.ajax({
            type: 'POST',
            url: searchUrl,
            data: {
                search: $(this).val(),
                lang: searchUrl.split('/')[1]
            },
            success: function (response) {

                $('#search-result-div').addClass('search-result');

                $('.autocomplete-search').each(function () {
                    $(this).remove();
                });

                if (response != '') {
                    let productsResult = JSON.parse(response).products;

                    for (let i = 0; i < productsResult.length; i++) {
                        $('.search-result').append("<a class='autocomplete-search' target='_blank' href='/" + searchUrl.split('/')[1] + "/card/" + productsResult[i].id + "'>" + productsResult[i].title + "</a>");
                    }

                    if (productsResult.length == 1) {
                        $(document).on('keypress', function (event) {
                            if (event.key == 'Enter') {
                                if ($('.autocomplete-search').length == 1) {
                                    window.location.href = $('.autocomplete-search').attr('href');
                                    return false;
                                }
                            }
                        });
                    }

                    $(document).on('keypress', function (event) {
                        if (event.key === 'Enter') {
                            window.location.href = $('.search-header__form').attr('data-search') + '?search=' + $('input[name="search"]').val();
                        }
                    });
                } else {
                    $('#search-result-div').removeClass('search-result');
                }
            }
        });
    });

    $(document).on('click', '.search-header__close', function () {
        $('.autocomplete-search').each(function () {
            $(this).remove();
        });

        $('#search-result-div').removeClass('search-result');

        $('.search-header__input').val('');
    });

    if ($('.cart').length || $('.order').length) {
        $('._cart').css('pointer-events', 'none');
        $('.cart-header').remove();
    }

    let oneCounter = 0;

    $(document).on('click', '.quantity__button_plus, .quantity__button_minus', function (event) {
        event.preventDefault();

        let parentDiv = '';
        let currentQuantity = $(this).parent().find('.quantity__input input').val();
        let element = $(this);

        if ($('.cart').length) {
            parentDiv = $(this).parent().parent();
        }

        if (currentQuantity == '1') {
            $(this).parent('delete_element');
        }

        if (currentQuantity == '1') {
            oneCounter = oneCounter + 1;
        }

        if ($(this).parent().hasClass('delete_element') && currentQuantity == '1' || $(this).parent().hasClass('_min') && oneCounter >= '2') {
            let lclang = $('.language-header__item._active').attr('data-lang');

            if (confirm(deleteImagePlaceholder)) {
                localStorage.removeItem('currentItem');
                $.ajax({
                    type: 'POST',
                    url: '/delete_from_cart',
                    data: {
                        productId: $(this).attr('data-key')
                    },
                    success: function (response) {

                        if ($('.cart').length) {
                            parentDiv.remove();
                            calculate_cart_items_page();
                        }

                        $.ajax({
                            type: 'GET',
                            url: '/count_cart_items',
                            success: function (response) {
                                $('.action-main-header__count').text(response);
                            }
                        });

                        $.ajax({
                            type: 'GET',
                            url: '/' + lclang + '/update_cart',
                            data: {
                                lclang: lclang
                            },
                            success: function (response) {
                                if (!$('.cart').length && !$('.order').length) {
                                    $('.cart-header').remove();
                                    $('.main-header__action').append(JSON.parse(response));
                                }

                                calculate_cart_items();
                            }
                        });

                        oneCounter = 0;

                        if ($('.product-main-cart').length == 0) {
                            $('.main-cart__delete').css('display', 'none');
                            $('.basket_empty').removeAttr('style');
                            $('.cart__wrapper').css('display', 'none');
                        }

                        toastr.success(productRemovedFromCart);
                    }
                });
            } else {
                let total = 0;
                let totalNewPrice = 0;
                let currentPrice = $(this).parent().find('.quantity__input input').val() * parseFloat($(this).parent().find('.quantity__input').attr('data-price'));

                // if ($(this).parent().next().hasClass('product-main-cart__total')) {
                //     $(this).parent().next().text(currentPrice.toLocaleString(undefined, {
                //         minimumFractionDigits: 0
                //     }) + '.-');
                // } else {
                //     $(this).parent().next().find('._new_price').text(currentPrice.toLocaleString(undefined, {
                //         minimumFractionDigits: 0
                //     }) + '.-');
                // }

                $.ajax({
                    type: 'POST',
                    url: '/update_product_amount',
                    data: {
                        productKey: $(this).attr('data-key'),
                        amount: $(this).parent().find('.quantity__input input').val()
                    },
                    success: function (response) {
                        if ($('.cart').length) {
                            element.parent().next().text(JSON.parse(response).price.toLocaleString(undefined, {
                                minimumFractionDigits: 0
                            }) + '.-');
                        }

                        element.parent().next().find('._new_price').text(JSON.parse(response).price.toLocaleString(undefined, {
                            minimumFractionDigits: 0
                        }) + '.-');

                        $('.footer-cart-header__total span').text(JSON.parse(response).total.toLocaleString(undefined, {
                            minimumFractionDigits: 0
                        }) + '.-');

                        $('.sidebar_total').text(JSON.parse(response).total.toLocaleString(undefined, {
                            minimumFractionDigits: 0
                        }) + '.-');

                        $.ajax({
                            type: 'GET',
                            url: '/count_cart_items',
                            success: function (response) {
                                $('.action-main-header__count').text(response);
                            }
                        });
                    }
                });

                // $('.product-main-cart__total').each(function () {
                //     total = total + parseInt($(this).text().replace('.-', '').replace(',', ''));
                // });

                // $('._new_price').each(function () {
                //     totalNewPrice = totalNewPrice + parseInt($(this).attr('data-price') * $(this).parent().prev().find('.quantity__input input').val());
                // });

                // $('.footer-cart-header__total span').text(totalNewPrice.toLocaleString(undefined, {
                //     minimumFractionDigits: 0
                // }) + '.-');

                // $('.sidebar_total').text(total.toLocaleString(undefined, {
                //     minimumFractionDigits: 0
                // }) + '.-');
            }
        } else {
            if (currentQuantity > '1') {
                oneCounter = 0;
                $(this).parent().removeClass('delete_element');
            }

            let total = 0;
            let totalNewPrice = 0;
            let currentPrice = $(this).parent().find('.quantity__input input').val() * parseFloat($(this).parent().find('.quantity__input').attr('data-price'));

            // if ($(this).parent().next().hasClass('product-main-cart__total')) {
            //     $(this).parent().next().text(currentPrice.toLocaleString(undefined, {
            //         minimumFractionDigits: 0
            //     }) + '.-');
            // } else {
            //     $(this).parent().next().find('._new_price').text(currentPrice.toLocaleString(undefined, {
            //         minimumFractionDigits: 0
            //     }) + '.-');
            // }

            $.ajax({
                type: 'POST',
                url: '/update_product_amount',
                data: {
                    productKey: $(this).attr('data-key'),
                    amount: $(this).parent().find('.quantity__input input').val()
                },
                success: function (response) {
                    if ($('.cart').length) {
                        element.parent().next().text(JSON.parse(response).price.toLocaleString(undefined, {
                            minimumFractionDigits: 0
                        }) + '.-');
                    }

                    element.parent().next().find('._new_price').text(JSON.parse(response).price.toLocaleString(undefined, {
                        minimumFractionDigits: 0
                    }) + '.-');

                    $('.footer-cart-header__total span').text(JSON.parse(response).total.toLocaleString(undefined, {
                        minimumFractionDigits: 0
                    }) + '.-');

                    $('.sidebar_total').text(JSON.parse(response).total.toLocaleString(undefined, {
                        minimumFractionDigits: 0
                    }) + '.-');

                    $.ajax({
                        type: 'GET',
                        url: '/count_cart_items',
                        success: function (response) {
                            $('.action-main-header__count').text(response);
                        }
                    });
                }
            });

            // $('.product-main-cart__total').each(function () {
            //     total = total + parseInt($(this).text().replace('.-', '').replace(',', ''));
            // });

            // $('._new_price').each(function () {
            //     totalNewPrice = totalNewPrice + parseInt($(this).attr('data-price') * $(this).parent().prev().find('.quantity__input input').val());
            // });

            // $('.footer-cart-header__total span').text(totalNewPrice.toLocaleString(undefined, {
            //     minimumFractionDigits: 0
            // }) + '.-');

            // $('.sidebar_total').text(total.toLocaleString(undefined, {
            //     minimumFractionDigits: 0
            // }) + '.-');
        }
    });

    $(document).on('click', 'input[name="delivery"]', function () {
        if ($(this).val() == 'store') {
            // $('select[name="locality"]').removeAttr('required');
            $('input[name="locality"]').removeAttr('required');
            $('input[name="address"]').removeAttr('required');
        } else {
            // $('select[name="locality"]').attr('required', 'required');
            $('input[name="locality"]').attr('required', 'required');
            $('input[name="address"]').attr('required', 'required');
        }
    });

    $.ajax({
        type: 'GET',
        url: '/count_cart_items',
        success: function (response) {
            $('.action-main-header__count').text(response);
        }
    });

    calculate_cart_items();

    $(document).on('click', '.head-cart-header__delete, .main-cart__delete', function () {
        if (confirm(deleteImagePlaceholder + ' ?')) {
            $.ajax({
                type: 'POST',
                url: '/empty_cart',
                success: function (response) {
                    if (JSON.parse(response).success) {
                        location.reload();
                    } else {
                        toastr.error(basketIsEmpty);
                    }
                }
            });
        }
    });

    $(document).on('click', '.info-card__cart', function () {

        let lclang = $('.language-header__item._active').attr('data-lang');

        $.ajax({
            type: 'POST',
            url: '/' + lclang + '/add_to_cart',
            data: {
                colorId: $('.colors-card__item._active').find('div').attr('data-color-id'),
                productId: $('.info-card__cart').attr('data-page-id'),
                amount: $('.card_input input').val(),
                lclang: lclang
            },
            success: function (response) {

                $.ajax({
                    type: 'GET',
                    url: '/count_cart_items',
                    success: function (response) {
                        $('.action-main-header__count').text(response);
                    }
                });

                $.ajax({
                    type: 'GET',
                    url: '/' + lclang + '/update_cart',
                    data: {
                        lclang: lclang
                    },
                    success: function (response) {
                        $('.cart-header').remove();
                        $('.main-header__action').append(JSON.parse(response));
                        calculate_cart_items();
                    }
                });

                $('.card_input').find('input').val(1);

                toastr.success(productAddedToCart);
            }
        });
    });

    $(document).on('click', '.banner__item', function () {
        if ($(this).attr('data-href') != '') {
            window.open($(this).attr('data-href'), '_blank');
        }

        return false;
    });

    // Enable Fancybox for any element with the `data-fancybox` attribute
    Fancybox.bind('[data-fancybox]', {
        // Your custom options
    });

    // Set custom options for elements with the `data-fancybox="gallery"` attribute
    Fancybox.bind('[data-fancybox="gallery"]', {
        // Your custom options
    });

    if ($('.order').length) {
        grecaptcha.ready(() => {
            grecaptcha.execute('6Lf4pfoqAAAAAEYiUDvtzXlhE2jvOpqDeAY4MZ_q', {
                action: 'contact'
            }).then(token => {
                let currentAction = $('.order__wrapper').attr('action');
                $('.order__wrapper').attr('action', currentAction + '?token=' + token);
            });
        });
    }

    $(document).on('click', '.feedback__submit', function (event) {
        event.preventDefault();

        grecaptcha.ready(() => {
            grecaptcha.execute('6LfPmtYiAAAAACJofbUnJQGP7YnVi5Cc1JWIaAgB', {
                action: 'contact'
            }).then(token => {

                if ($('input[name="name"]').val() == '' || $('input[name="email"]').val() == '' || $('textarea[name="comment"]').val() == '' || $('input[name="phone"]').val() == '') {
                    toastr.error(completeRequiredFields);
                    return false;
                }

                $.ajax({
                    type: "POST",
                    url: window.location.href + '?token=' + token,
                    data: {
                        name: $('input[name="name"]').val(),
                        email: $('input[name="email"]').val(),
                        phone: $('input[name="phone"]').val(),
                        comment: $('textarea[name="comment"]').val(),
                        token: token
                    },
                    success: function (response) {
                        location.reload();
                    },
                    error: function () {
                        return false;
                    }
                });
            });
        });
    })

    $(document).on('click', '.contacts-footer__title, .contacts-menu__title', function () {
        window.location.href = $(this).attr('data-href');
    });

    $(document).on('click', '.phone-main-header__item', function () {
        $('.phone-main-header__head').trigger('click');
    });

    if (!$('.card').length) {
        $(document).on('click', '.collors-product__circle', function () {
            $(this).parent().parent().find('li').each(function (index) {
                if ($(this).hasClass('active_color')) {
                    $(this).removeClass('active_color');
                }
            });

            $(this).parent().addClass('active_color');

            window.location.href = $(this).parent().attr('data-href');
        });
    }

    $(document).on('click', '.similar_product_color', function () {
        $(this).parent().parent().find('li').each(function (index) {
            if ($(this).hasClass('active_color')) {
                $(this).removeClass('active_color');
            }
        });

        $(this).parent().addClass('active_color');

        window.location.href = $(this).parent().attr('data-href');
    });

    if ($('.card').length) {
        if (getUrlParameter('color_id')) {
            $('.wrapper').addClass('hide-wrapper');

            $('.colors-card').find('.collors-product__circle').each(function () {
                if ($(this).attr('data-color-id') == getUrlParameter('color_id')) {
                    let item = $(this).parent().closest('.colors-card__item');
                    let itemActive = document.querySelector('.info-card__colors .colors-card__item._active');
                    let colorNow = document.querySelector('.info-card__color-now');
                    let colorNowCircle = colorNow.querySelector('div');
                    let colorNowName = colorNow.querySelector('p');

                    colorNowName.textContent = $(this).next().text();
                    colorNowCircle.setAttribute('style', $(this).attr("style"));

                    getCardColorImages(getUrlParameter('color_id'));
                }
            });

            $('.loader').fadeOut('slow');
            setTimeout(function () {
                $('.wrapper').removeClass('hide-wrapper');
            }, 0);
        } else {
            $('.colors-card__item').eq(0).addClass('_active');
        }

        $(document).on('click', '.card-color', function () {
            getCardColorImages($(this).attr('data-color-id'));
        });
    }
});

let phoneInput = document.getElementById('order_phone');

phoneInput.addEventListener('input', function (e) {
    var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,2})(\d{0,2})(\d{0,2})(\d{0,2})/);
    e.target.value = !x[2] ? '+' + x[1] : '+' + x[1] + ' (' + x[2] + ') ' + (x[3] ? ' ' + x[3] : '') + (x[4] ? '-' + x[4] : '') + (x[5] ? '-' + x[5] : '');
});

$(document).on('click', '.sidebar-cart__button', function () {
    if (phoneInput.value.length < 19) {
        alert(completePhoneInput);
        return false;
    }
});